import "./Header.scss";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/logo_eVHC.png";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import i18n from "../services/i18n";
import CodeSelectBox from "../components/common/CodeSelectBox";
import Menu from "./Menu";

const Header = () => {
  const navigate = useNavigate();
  const [loginStatus, setLoginStatus] = useState("Authorized");
  const [lang, setLang] = useState(i18n.language);
  const sbLang = [{ code: "eng", codeDesc: "English" }];

  useEffect(() => {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

    if (!userInfo?.grantType || !userInfo?.accessToken) {
      setLoginStatus("Unauthorized");
    }
  }, []);

  const handleLangChange = (e) => {
    setLang(e.target.value);
    i18n.changeLanguage(e.target.value);
  };

  const handleLogoutClick = (e) => {
    e.preventDefault();

    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <div id="header_wrap">
      <div className="header">
        <h1>
          <Link to="/pdi-status/regional-record">
            <img src={logo} alt="Logo" />
          </Link>
        </h1>
        <div className="top_right">
          <Link style={{ fontWeight: "bold", pointerEvents: "none" }}>
            {loginStatus}
          </Link>
          <Link to="/mypage/checkpw">MyPage</Link>
          <Link to="/pdi-status/regional-record">Home</Link>
          <Link to="/logout" onClick={handleLogoutClick}>
            Logout
          </Link>
          <CodeSelectBox
            width="140px"
            value={lang}
            codes={sbLang}
            onChange={handleLangChange}
          ></CodeSelectBox>
        </div>
      </div>
      <Menu />
    </div>
  );
};

export default Header;
